export default __webpack_public_path__ + "static/media/paper3.41e4db32.svg";